import React from "react";
import moment from "moment-timezone";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import TimeTotal from "../helpers/TimeTotal.jsx";

const CardHeader = ({ item }) => {
  const tz = global.config.getTimeZone();

  const formatDateWithLabel = (dateValue) => {
    // Key is now "YYYY-MM-DD" in the user's timezone — parse with explicit format + timezone
    // so moment doesn't misinterpret it as browser-local midnight (which shifts day for UTC- zones)
    const inputDay = moment.tz(dateValue, "YYYY-MM-DD", tz).startOf("day");
    if (!inputDay.isValid()) return "";

    const today = moment().tz(tz).startOf("day");
    const yesterday = today.clone().subtract(1, "day");

    if (inputDay.isSame(today, "day")) return "Today";
    if (inputDay.isSame(yesterday, "day")) return "Yesterday";
    return inputDay.format("ddd, MMM D");
  };

  return (
    <Card.Header>
      <Row className="card-header-sec">
        <Col className="card-header-date">
          {formatDateWithLabel(item?.[0])}
        </Col>
        <div className="separation-head"></div>
        <Col className="card-timer">
          <TimeTotal item={item} />
        </Col>
      </Row>
    </Card.Header>
  );
};

export default CardHeader;